// extracted by mini-css-extract-plugin
export default {"container":"style_container__DK5uo","title":"style_title__QDoil","image":"style_image__GaBS+"};